import { EcommerceAPIApi as EcommerceApi, Citation } from '@parkingbase/ecommerce-api-dev';
import type { RawAxiosRequestConfig } from 'axios';
import { BaseApiService } from './baseApi.service';
import type {
  CitationAppealRequest,
  CitationLookupFactors,
  CitationPayRequest,
  PublicCitationView,
} from './citation-public.types';

export class CitationService extends BaseApiService {
  protected integrationsApi: EcommerceApi;

  constructor() {
    super();
    this.integrationsApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  async getCitationsByUserId(startDateTime?: string, endDateTime?: string): Promise<Citation[]> {
    const response = await this.integrationsApi.getCitationsByUserId(startDateTime, endDateTime);
    return response.data;
  }

  /** Looks up a citation as a signed-out visitor (PB-4752). */
  async lookupPublicCitation(
    factors: CitationLookupFactors,
    options?: RawAxiosRequestConfig
  ): Promise<PublicCitationView> {
    const response = await this.apiClient.post('/citation/public/lookup', factors, options);
    return response.data;
  }

  /** Pays a citation as a guest (PB-4752). */
  async payPublicCitation(
    request: CitationPayRequest,
    options?: RawAxiosRequestConfig
  ): Promise<PublicCitationView> {
    const response = await this.apiClient.post('/citation/public/pay', request, options);
    return response.data;
  }

  /** Files an appeal as a guest (PB-4770). */
  async appealPublicCitation(
    request: CitationAppealRequest,
    options?: RawAxiosRequestConfig
  ): Promise<PublicCitationView> {
    const response = await this.apiClient.post('/citation/public/appeal', request, options);
    return response.data;
  }
}
